import React, { useState, useEffect } from "react";
import $ from "jquery";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "datatables.net-dt/js/dataTables.dataTables";
import "../../../../src/styles/userManagement.css";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import Planning from './CreateandEditPlan'

export default function EditPlan(props) {
  const [currentTab, setCurrentTab] = useState("1");
  const [editTab, setEditTab] = useState(true);
  const [deletemodalVisible, setDeletemodalVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };
  const data = [
    { "Name": "Ram", "Status": "New", "Critically": "Tier-3", "Last Assessment Date": "11-Feb-2020", "Last Assessment Status": "Open", "Recurrence Month": "August", "Third Party Contact Name": "Smith" },
    { "Name": "Yash", "Status": "ReCurring", "Critically": "Tier-1", "Last Assessment Date": "09-Aug-2020", "Last Assessment Status": "Close", "Recurrence Month": "July", "Third Party Contact Name": "John" },
    { "Name": "Nidhi", "Status": "Off-boarding", "Critically": "Tier-3", "Last Assessment Date": "24-Nov-2020", "Last Assessment Status": "Open", "Recurrence Month": "June", "Third Party Contact Name": "Karen" },
    { "Name": "Raghu", "Status": "ReCurring", "Critically": "Tier-2", "Last Assessment Date": "16-Dec-2020", "Last Assessment Status": "Expired", "Recurrence Month": "December", "Third Party Contact Name": "Ryan" },
    { "Name": "Asha", "Status": "New", "Critically": "Tier-1", "Last Assessment Date": "07-Jul-2020", "Last Assessment Status": "Open", "Recurrence Month": "March", "Third Party Contact Name": "Dulip" },
    { "Name": "Akhil", "Status": "Off-boarding", "Critically": "Tier-3", "Last Assessment Date": "06-May-2020", "Last Assessment Status": "Close", "Recurrence Month": "November", "Third Party Contact Name": "Jain" },
  ]

  $(document).on("click", "[id*='edit_']", function () {
    setEditTab(false);
  });
  const handleBack = () => {
    setEditTab(true);
  }
  $(document).on("click", "[id*='editplanDelete_*_*']", function (e) {
    setVisible(true);
    setDeletemodalVisible(true);
  });
  const handleCancel = e => {
    setVisible(false)
    setDeletemodalVisible(false)
  };

  useEffect(() => { }, []);

  // $(document).ready(function () {
  //   $("#editplan").DataTable({
  //     "scrollX": true, "initComplete": function (settings, json) {
  //       $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
  //     },
  //     data: data,
  //     destroy: true,
  //     info: false,
  //     language: {
  //       paginate: {
  //         next: "&gt;", // or '→'
  //         previous: "&lt;", // or '←'
  //       },
  //     },
  //     fields: [
  //       {
  //         label: "Name:",
  //         name: "Name",
  //       },
  //       {
  //         label: "Status:",
  //         name: "Status",
  //       },
  //       {
  //         label: "Critically:",
  //         name: "Critically",
  //       },
  //       {
  //         label: "Last Assessment Date:",
  //         name: "Last Assessment Date",
  //       },
  //       {
  //         label: "Last Assessment Status:",
  //         name: "Last Assessment Status",
  //       },
  //       {
  //         label: "Recurrence Month:",
  //         name: "Recurrence Month",
  //       },
  //       {
  //         label: "Third Party Contact Name:",
  //         name: "Third Party Contact Name",
  //       },
  //     ],
  //     columns: [
  //       { data: "Name" },
  //       { data: "Status" },
  //       { data: "Critically" },
  //       { data: "Last Assessment Date" },
  //       {
  //         render: function (data, type, row) {
  //           let stylesClass;
  //           switch (row["Last Assessment Status"]) {
  //             case "Expired":
  //               stylesClass = "Expired-status";
  //               break;
  //             case "Open":
  //               stylesClass = "Open-status";
  //               break;
  //             case "Close":
  //               stylesClass = "Close-status";
  //               break;
  //             default:
  //               stylesClass = "";
  //           }
  //           return `<div class="bia-status ${stylesClass}">${row["Last Assessment Status"]}</div>`;
  //         },
  //       },
  //       { data: "Recurrence Month" },
  //       { data: "Third Party Contact Name" },
  //       {
  //         render: function (data, type, row) {
  //           return (
  //             '<span class=" appkiticon icon-edit-fill pointer" data-toggle="modal" data-target="#updateModal" id="edit_' +
  //             row.vendor_id +
  //             '"> </span> &nbsp;<span class=" appkiticon icon-delete-fill pointer" data-toggle="modal" data-target="#deleteModal" id="editplanDelete_*_*' +
  //             row.vendor_id +
  //             '"> </span>'
  //           );
  //         },
  //         orderable: false,
  //       },
  //     ],
  //   });
  // });

  return (

    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab value="1" label="Edit Plan">
            {editTab ? <div className="col-lg-12 mt-3 pl-1">
              <table id="editplan" className="table menu-tableAlignment-width">
                <thead className="table-header-etp">
                  <tr>
                    <th>Third Party Name</th>
                    <th>Status</th>
                    <th>Critically </th>
                    <th>Last Assessment Date</th>
                    <th>Last Assessment Status</th>
                    <th>Recurrence Month</th>
                    <th>Third Party Contact Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </table>
            </div> :
              <Planning handleBack={handleBack} />}
          </Tab>
        </Tabs>
        <Modal
          className="baseline-modal-showcase"
          visible={deletemodalVisible}
          onCancel={handleCancel}
          title="Are you sure you want to delete?"
        >
          <ModalFooter>
            <div className="modal-footer">
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
              </button>

              <button
                type="submit"
                className="save-button m-l-2"
              >
                Yes
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  )
};

